import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const UpcomingTripCard = ({ trip, onViewDetails, onDownloadTicket, onContactSupport }) => {
  const calculateDaysLeft = (date) => {
    const today = new Date();
    const tripDate = new Date(date);
    const diffTime = tripDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  };

  const daysLeft = calculateDaysLeft(trip.startDate);

  return (
    <div className="bg-card rounded-xl shadow-soft border border-border overflow-hidden">
      <div className="relative h-48 sm:h-56">
        <Image
          src={trip.image}
          alt={trip.destination}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        <div className="absolute bottom-4 left-4 right-4">
          <h3 className="text-white text-xl font-heading font-semibold mb-1">
            {trip.destination}
          </h3>
          <p className="text-white/90 text-sm font-caption">
            {trip.duration} • {trip.packageType}
          </p>
        </div>
        <div className="absolute top-4 right-4">
          <div className="bg-primary text-primary-foreground px-3 py-1 rounded-full text-sm font-medium">
            {trip.status}
          </div>
        </div>
      </div>

      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-sm text-muted-foreground mb-1">Departure Date</p>
            <p className="font-medium text-foreground">
              {new Date(trip.startDate).toLocaleDateString('en-IN', {
                day: '2-digit',
                month: 'short',
                year: 'numeric'
              })}
            </p>
          </div>
          <div className="text-right">
            <p className="text-sm text-muted-foreground mb-1">Days Left</p>
            <div className="flex items-center space-x-2">
              <Icon name="Clock" size={16} className="text-primary" />
              <span className="font-semibold text-primary text-lg">
                {daysLeft > 0 ? daysLeft : 'Today'}
              </span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 mb-4">
          <div className="flex items-center space-x-2">
            <Icon name="MapPin" size={16} className="text-muted-foreground" />
            <span className="text-sm text-foreground">{trip.location}</span>
          </div>
          <div className="flex items-center space-x-2">
            <Icon name="Users" size={16} className="text-muted-foreground" />
            <span className="text-sm text-foreground">{trip.travelers} Travelers</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-2">
          <Button
            variant="default"
            size="sm"
            onClick={() => onViewDetails(trip.id)}
            iconName="Eye"
            iconPosition="left"
            className="flex-1"
          >
            View Details
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => onDownloadTicket(trip.id)}
            iconName="Download"
            iconPosition="left"
            className="flex-1"
          >
            Download
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onContactSupport(trip.id)}
            iconName="MessageCircle"
            iconPosition="left"
            className="flex-1"
          >
            Support
          </Button>
        </div>
      </div>
    </div>
  );
};

export default UpcomingTripCard;